const schema = () => ({
  type: 'object',
  properties: {
    condition: {
      type: 'boolean',
      title: 'تمام هزینه',
      default: false,
    },
  },
  allOf: [
    {
      if: {
        properties: {
          condition: {
            const: false,
          },
        },
      },
      then: {
        properties: {
          amount: {
            type: 'number',
            title: 'مقدار',
          },
        },
      },
    },
  ],
});

export default schema;
